$(() => {
  registerFileInputListeners();
});

function registerFileInputListeners() {
  $('.file-input button').click(e => {
    e.preventDefault();
    $(e.target).next().click();
  });

  $('.file-input input[type="file"]').change(e => {
    $(e.target).next().html(
      $(e.target).attr("multiple") ?
        e.target.files.length + ' files selected.' :
        $(e.target).val().split(/(\\|\/)/g).pop()
    );
  });

  $('.file-input [data-action="cancel"]').click(e => {
    $('.file-input input[type="file"]').val("");
    $('.file-input input[type="file"]').next().html(
      'No file selected'
    );
  });
}
